import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

/**
 * EventDetails - Displays event metadata (type, description, timestamp, location, etc.)
 * @param {boolean} isMatchEvent - Whether this is a match event
 * @param {boolean} isMultiDatasetMatchEvent - Whether this is a multi-dataset match event
 * @param {boolean} isNoteEvent - Whether this is a note event
 * @param {string} eventLabel - Event type label
 * @param {string} description - Event description
 * @param {string} dateTimeStr - Formatted date/time string
 * @param {string} matchSource - Match source ('face_match' or 'human_match')
 * @param {Object} location - Location object with latitude/longitude
 * @param {string} interestReason - Reason for interest level
 */
export default function EventDetails({
  isMatchEvent,
  isMultiDatasetMatchEvent,
  isNoteEvent,
  eventLabel,
  description,
  dateTimeStr,
  matchSource,
  location,
  interestReason
}) {
  return (
    <>
      {!isMatchEvent && !isMultiDatasetMatchEvent && !isNoteEvent && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          <strong>{eventLabel}:</strong> {description}
        </Typography>
      )}
      {isNoteEvent && (
        <>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Type:</strong> {eventLabel}
          </Typography>
          {description && (
            <>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Description:</strong>
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
                {description}
              </Typography>
            </>
          )}
        </>
      )}
      {interestReason && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          <strong>Reason for Interest:</strong> {interestReason}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
          <strong>Created:</strong> {dateTimeStr}
        </Typography>
        {(isMatchEvent || isMultiDatasetMatchEvent) && matchSource && (
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
            <strong>Source:</strong> {matchSource === 'face_match' ? 'AI Match' : 'Human Match'}
          </Typography>
        )}
        {location && (
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
            <strong>Location:</strong> {location.latitude.toFixed(6)}, {location.longitude.toFixed(6)}
          </Typography>
        )}
      </Box>
    </>
  );
}
